/**
 * Supabase Client Configuration
 * Optimized settings for connection pooling and performance
 */

export const supabaseConfig = {
    auth: {
        autoRefreshToken: true,
        persistSession: true,
        detectSessionInUrl: true,
        flowType: 'pkce' as const,
    },
    global: {
        headers: {
            'X-Client-Info': 'insighthread-web',
        },
    },
    db: {
        schema: 'public',
    },
    realtime: {
        params: {
            eventsPerSecond: 10,
        },
    },
}
